__turbopack_context__.v({
  "container": "styles-module__q9S8JW__container",
  "continueWrap": "styles-module__q9S8JW__continueWrap",
  "footer": "styles-module__q9S8JW__footer",
  "header": "styles-module__q9S8JW__header",
  "headerNavigation": "styles-module__q9S8JW__headerNavigation",
});
